export default {
  'newIndex':'h5_home_page',
  'register':'h5_registion_page',
  'login':'h5_log_in_page',
  'tradeCompetition':'h5_activity_page_sodi_airdrop',
  'listingTokenFlow': 'h5_free_market_create_pair_process_page',
  'verification': 'h5_official_verification_page',
  'AnnualReport':'h5_2024_year_report_page'
}



// WEBPACK FOOTER //
// ./src/utils/route_page_id.js